import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Wifi1BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_1_bar"}/>
}
